export default {
    groups(state) {
        return state.connectionGroups
    },

    singleGroup(state, id) {
        console.log('state id in singelGroup', id)
        return state.connectionGroups.find(group => group.id === id)
    },



}

